import { FwTrackingEvent } from './FwTrackingEvent'

/**
 * Liste des événements MIGRÉS vers Amplitude.
 *
 * Migration Segment → Amplitude, progressive (event par event).
 * Routage dans `TrackingService.sendEvent` :
 *   - événement listé ici            → envoyé à Amplitude
 *   - événement absent (non migré)   → envoyé à Segment, comme avant
 *
 * Aucun événement n'est perdu : tant qu'un événement n'est pas ajouté ici, il
 * continue de partir vers Segment. On migre un événement à la fois : on l'ajoute
 * ici, on déploie, on vérifie qu'il remonte bien dans Amplitude, puis on passe
 * au suivant. Les nouveaux événements (nouvelles features) naissent directement
 * dans cette liste.
 *
 * Événements restant à migrer (encore sur Segment) :
 *   FwTrackingEvent.DISPLAY_PATIENT
 *   FwTrackingEvent.SEARCH_PATIENT
 *   FwTrackingEvent.DELETE_PATIENT
 *   FwTrackingEvent.OPEN_EDIT_PATIENT_MODAL
 *   FwTrackingEvent.OPEN_IMPORT_PATIENT_MODAL
 *   FwTrackingEvent.DISPLAY_MEDICAL_EVENT
 *   FwTrackingEvent.SELECT_MEDICAL_EVENT_DOCUMENT
 *   FwTrackingEvent.SELECT_MEDICAL_EVENT_FILE
 *   FwTrackingEvent.SELECT_MEDICAL_EVENT_FILE_INSTANCE
 *   FwTrackingEvent.SELECT_MEDICAL_EVENT_OBSERVATIONS
 *   FwTrackingEvent.SELECT_MEDICAL_EVENT_QUESTIONNAIRE
 *   FwTrackingEvent.INSERT_MEDICAL_EVENT_QUESTIONNAIRE
 *   FwTrackingEvent.INSERT_MEDICAL_EVENT_DOCUMENT
 *   FwTrackingEvent.INSERT_MEDICAL_EVENT_FILE
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_TITLE
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_DATE
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_OBSERVATIONS
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_FILE
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_DOCUMENT_TITLE
 *   FwTrackingEvent.UPDATE_MEDICAL_EVENT_FILE_TITLE
 *   FwTrackingEvent.DELETE_MEDICAL_EVENT
 *   FwTrackingEvent.DELETE_MEDICAL_EVENT_DOCUMENT
 *   FwTrackingEvent.DELETE_MEDICAL_EVENT_FILE
 *   FwTrackingEvent.DELETE_MEDICAL_EVENT_FILE_INSTANCE
 *   FwTrackingEvent.DELETE_MEDICAL_EVENT_QUESTIONNAIRE
 *   FwTrackingEvent.TOGGLE_PATIENT_INFO_ACCORDION
 *   FwTrackingEvent.OPEN_DOCUMENT_MODAL
 *   FwTrackingEvent.OPEN_BILAN_MODAL
 *   FwTrackingEvent.OPEN_FILE_MODAL
 *   FwTrackingEvent.MAXIMIZE_PANEL_BUTTON_CLICK
 *   FwTrackingEvent.ARTICLES_MODAL_CLICK_SEE_LATER
 *   FwTrackingEvent.ARTICLES_MODAL_CLICK_HIDE
 *   FwTrackingEvent.USAGE_APP
 *   FwTrackingEvent.STATISTICS_DISPLAY
 *   FwTrackingEvent.MANAGER_VARIABLE_ADD
 *   FwTrackingEvent.MEDICAL_EVENT_VARIABLE_ADD
 *   FwTrackingEvent.RENDER_DOCUMENTS
 *   FwTrackingEvent.MSS_MEDICAL_EVENT
 *   FwTrackingEvent.SHOW_DOCUMENT_HISTORY
 *   FwTrackingEvent.RESTORE_DOCUMENT_REVISION
 */
export const AMPLITUDE_ENABLED_EVENTS = new Set<FwTrackingEvent>([
  // Dictée vocale — nouveaux événements, nativement sur Amplitude.
  FwTrackingEvent.DICTATION_START,
  FwTrackingEvent.DICTATION_END,

  // Ajouter ici les anciens événements au fur et à mesure de leur migration
  // depuis Segment (voir la liste en commentaire ci-dessus).
])

export const isAmplitudeEventEnabled = (event: FwTrackingEvent): boolean =>
  AMPLITUDE_ENABLED_EVENTS.has(event)
